import { useState, useEffect } from 'react';
import { useLazyQuery } from '@apollo/client';

// With offline support
const useLazyGetData = (query, offlineDBHandler = null, isNetworkOnly = false, rootDataObject = false) => {

    const [triggerFunction, {
        data: gqlData, loading: gqlLoading, error: gqlError
    }] = useLazyQuery(query, isNetworkOnly ? {
        fetchPolicy: 'network-only', // Doesn't check cache before making a network request
    } : {});

    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [errorCode, setErrorCode] = useState(null);

    // Bind gql changes to the component states
    useEffect(() => {
        setData(gqlData && (rootDataObject ? gqlData : gqlData[Object.keys(gqlData)[0]]))
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [gqlData]);
    useEffect(() => { setLoading(gqlLoading) }, [gqlLoading]);
    useEffect(() => {
        setError(gqlError?.toString())
        setErrorCode(gqlError?.graphQLErrors?.[0]?.extensions?.code
      || gqlError?.networkError?.result?.errors?.[0]?.extensions?.code)
    }, [gqlError, gqlData]);

    // eslint-disable-next-line consistent-return
    const submitFunction = async (dataObject) => {
        if (window.navigator.onLine) {
            // online, save to the server
            return triggerFunction({ variables: dataObject });
        }
        else if (offlineDBHandler) {
            setLoading(true);
            // offline, get from the offline database via the provided handler
            try {
                const offlineSaveResult = await offlineDBHandler(dataObject);
                if (offlineSaveResult?.success) {
                    setData(offlineSaveResult.data);
                }
                else if (offlineSaveResult && !offlineSaveResult.success && offlineSaveResult.code === 403) {
                    setError('Error: Permission Denied!');
                }
                else {
                    setError('An error occured while trying to get data, try again when you have internet connection!');
                }
            }
            catch (err) {
                setError('An error occured while trying to get data, try again when you have internet connection!');
            }
            // offline, handler not provided, return 'offline' error
            setLoading(false);
        }
        else {
            // offline, handler not provided, return 'offline' error
            setError('This action is not supported in offline mode!');
        }
    }

    return [submitFunction, {
        data, loading, error, errorCode
    }];
}

export default useLazyGetData;
